export default {
  setPayPeriods: (state, payPeriods) => {
    state.payPeriods = payPeriods
  },
  setLoading: (state, loading) => {
    state.payPeriodsLoading = loading
  }
}
